/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect'
import type { State } from '@src/redux/configureStore'
import { orderBy } from 'lodash'

const getSearchData = (state: State) =>
  state.autocomplete.searchData || ([] as string[])

export const getSearchDataSelector = createSelector(
  [getSearchData],
  (data = []) => orderBy(data, x => x, 'asc') || []
)

export const getSearchQuery = (state: State) => state.autocomplete.searchQuery

export type SearchData = ReturnType<typeof getSearchDataSelector>
